import { createSelector } from 'reselect';

const selectResources = (state: any) => state.resources;


export const selectResourcesCurrentItem = createSelector([selectResources], (resources) => resources.current);

export const selectResourcesListItems = createSelector([selectResources], (resources) => resources.list);

export const selectResourcesItemById = (itemId: any) =>
    createSelector(selectResourcesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
export const selectResourcesQueryItems = createSelector([selectResources], (resources) => resources.query);


export const selectResourcesCreatedItem = createSelector([selectResources], (resources) => resources.create);

export const selectResourcesUpdatedItem = createSelector([selectResources], (resources) => resources.update);

export const selectResourcesReadItem = createSelector([selectResources], (resources) => resources.read);

export const selectResourcesDeletedItem = createSelector([selectResources], (resources) => resources.delete);

export const selectResourcesSearchedItems = createSelector([selectResources], (resources) => resources.search);

export const selectResourcesItemsCount = createSelector([selectResources], (resources) => resources.count);

export const selectResourcesItemsFilter = createSelector([selectResources], (resources) => resources.filter);